import type {
  AccessPermission,
  AccessType,
  InvitationStatus,
  MemberRole,
  SessionAuthMethod,
  SessionEndReason,
  SessionStatus,
} from '@viewer/protocol';

export const roleLabel: Record<MemberRole, string> = {
  owner: 'Proprietário',
  admin: 'Administrador',
  member: 'Membro',
};

export const permissionLabel: Record<AccessPermission, string> = {
  view: 'Visualizar tela',
  control: 'Controlar computador',
  file_transfer: 'Transferir arquivos',
  clipboard: 'Área de transferência',
  audio: 'Áudio',
  admin: 'Administrar o computador',
};

export const accessTypeLabel: Record<AccessType, string> = {
  view: 'Somente visualização',
  control: 'Controle total',
};

export const authMethodLabel: Record<SessionAuthMethod, string> = {
  manual_accept: 'Aceite manual',
  access_password: 'Senha de acesso',
  unattended: 'Sem supervisão',
};

export const sessionStatusLabel: Record<SessionStatus, string> = {
  pending: 'Aguardando',
  active: 'Em andamento',
  rejected: 'Recusada',
  ended: 'Encerrada',
  expired: 'Expirada',
};

export const endReasonLabel: Record<SessionEndReason, string> = {
  host_ended: 'encerrada pelo computador remoto',
  viewer_ended: 'encerrada por quem acessou',
  host_offline: 'computador remoto caiu',
  viewer_offline: 'quem acessou caiu',
  expired: 'tempo esgotado',
  server_shutdown: 'servidor reiniciado',
  access_revoked: 'permissão retirada',
};

export const invitationStatusLabel: Record<InvitationStatus, string> = {
  pending: 'Pendente',
  accepted: 'Aceito',
  revoked: 'Cancelado',
  expired: 'Vencido',
};

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export function formatRelative(iso: string | null): string {
  if (!iso) return 'nunca';
  const diff = Date.now() - new Date(iso).getTime();
  const minutes = Math.round(diff / 60_000);
  if (minutes < 1) return 'agora';
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  return formatDateTime(iso);
}
